<template>
  <div>
    <h1>This is the Second Route</h1>
    <p>Welcome to the second route!</p>
  </div>
</template>
